export const navLinks = [
  { label: '首页', href: '/' },
  { label: '电视剧', href: '/category/tv-series' },
  { label: '电影', href: '/category/movies' },
  { label: '综艺', href: '/category/variety' },
  { label: '动漫', href: '/category/anime' },
  { label: '关于我们', href: '/about' },
];

export const categories = [
  { id: 'all', name: '全部', slug: 'all', icon: 'ri-grid-line' },
  { id: 'tv-series', name: '电视剧', slug: 'tv-series', icon: 'ri-tv-line' },
  { id: 'movies', name: '电影', slug: 'movies', icon: 'ri-film-line' },
  { id: 'variety', name: '综艺', slug: 'variety', icon: 'ri-live-line' },
  { id: 'anime', name: '动漫', slug: 'anime', icon: 'ri-ghost-line' },
  { id: 'documentary', name: '纪录片', slug: 'documentary', icon: 'ri-earth-line' },
  { id: 'short', name: '短视频', slug: 'short', icon: 'ri-video-line' },
  { id: 'kids', name: '少儿', slug: 'kids', icon: 'ri-emotion-line' },
];

export const footerLinks = {
  about: [
    { label: '关于桔子视频', href: '/about' },
    { label: '品牌故事', href: '/about#brand' },
    { label: '用户口碑', href: '/about#reputation' },
    { label: '联系我们', href: '/about#contact' },
  ],
  help: [
    { label: '常见问题', href: '/about#faq' },
    { label: '播放帮助', href: '/about#play-help' },
    { label: '意见反馈', href: '/about#contact' },
    { label: '版权声明', href: '/about#copyright' },
  ],
  partner: [
    { label: '91视频网站', href: '#' },
    { label: '久久视频', href: '#' },
    { label: '菠萝视频', href: '#' },
    { label: '广告合作', href: '/about#contact' },
  ],
};